<template>
	<div>
		<q-table :data="bundles"
				 :columns="columns"
				 :visible-columns="visibleColumns"
				 :rows-per-page-options="rowsPerPageOptions"
				 :pagination.sync="pagination"
				 :loading="loading"
				 :selection="selection"
				 :selected.sync="selected"
				 @selection="bundleSelection"
				 row-key="intBundleId"
				 class="sticky-header-table"
		>
			<template v-slot:top-left v-if="showTitle">
				<div class="q-table__title table-title">
					<p>{{ speciesName }}</p>
					<p>{{ $t('veneerLog') }} {{ logNo }}</p>
				</div>
			</template>
			<template v-slot:top-right v-if="allowDownload">
				<q-btn @click="downloadMeasurementList" :label="$t('button.download')" color="primary" icon="cloud_download" no-caps no-wrap/>
			</template>
			<template v-slot:body-cell-originalLog="cell">
				<q-td>
					<router-link v-if="cell.value.link" :to="cell.value.link" target="_blank">{{ cell.value.logNo }}</router-link>
					<template v-else>-</template>
				</q-td>
			</template>
		</q-table>
	</div>
</template>

<script>
	import {DOWNLOAD_MEASUREMENTLIST, FETCH_BUNDLES_FOR_LOG, FETCH_BUNDLES_FOR_VIRTUAL_LOG} from "@/store/actions.type";
	import {mapGetters} from "vuex";
	import LogPropertiesResolver from "@/mixins/LogPropertiesResolver";
	import {logSearchPageSize, measurementListPageSize} from "@/common/config";
	import PaginationLabel from "@/mixins/PaginationLabel";

	export default {
		name: "MeasurementList",
		mixins: [LogPropertiesResolver, PaginationLabel],
		props: {
			props: Object,
			propBundles: {
				type: Array,
				default: function () {
					return [];
				}
			},
			showTitle: {
				type: Boolean,
				default: true
			},
			allowDownload: {
				type: Boolean,
				default: true
			},
			selection: {
				type: String,
				default: "none"
			}
		},
		data() {
			return {
				loading: false,
				bundles: [],
				visibleColumns: [
					'strBundleNo', 'intSheets', 'intLength', 'intWidth', 'decArea'
				],
				columns: [
					{name: 'strBundleNo', label: this.$t('bundle.packageNr'), field: 'strBundleNo'},
					{name: 'intSheets', label: this.$t('bundle.sheets'), field: 'intSheets'},
					{name: 'intLength', label: `${this.$t('bundle.length')} ${this.$t('unit.cm')}`, field: 'intLength'},
					{name: 'intWidth', label: `${this.$t('bundle.width')} ${this.$t('unit.cm')}`, field: 'intWidth'},
					{name: 'decArea', label: `${this.$t('bundle.area')} ${this.$t('unit.sqm')}`, field: 'decArea'},
					{name: 'originalLog', label: this.$t('bundle.originalLog'), field: row => this.getLogName(row)},
					{name: 'originalBundleNo', label: this.$t('bundle.originalBundleNo'), field: 'originalBundleNo'}
				],
				pagination: {
					page: 1,
					rowsPerPage: measurementListPageSize
				},
				rowsPerPageOptions: [measurementListPageSize],
				selected: []
			}
		},
		async mounted() {
			if (!this.bundles || !this.bundles.length) {
				if (this.propBundles && this.propBundles.length) {
					this.bundles = this.propBundles;
				} else {
					this.loading = true;
					this.bundles = this.props.isVirtual ?
						await this.$store.dispatch(FETCH_BUNDLES_FOR_VIRTUAL_LOG, this.log) :
						await this.$store.dispatch(FETCH_BUNDLES_FOR_LOG, this.log);
					this.loading = false;
				}
			}
			if(this.props.isVirtual && this.user) {
				this.visibleColumns = [...this.visibleColumns, 'originalLog', 'originalBundleNo'];
			}
		},
		computed: {
			...mapGetters(['log', 'user']),
			watchlistItem() {
				return this.props.watchlistItem;
			}
		},
		methods: {
			downloadMeasurementList() {
				this.$store.dispatch(DOWNLOAD_MEASUREMENTLIST, {
					veneerLog: this.log.uid || 0,
					logId: this.logId || 0,
					woodSpeciesName: this.speciesName,
					isVirtual: (this.props.isVirtual ? true : '')
				})
			},
			bundleSelection(details) {
				this.$emit('selection', details);
			},
			getLogName(bundle) {
				if(this.log && this.log.logsMeta) {
					const metaLog = this.log.logsMeta.find(logMeta => logMeta.logId === bundle.intLogId);
					if(metaLog && metaLog.hasOwnProperty('logNo')) {
						return {
							logNo: metaLog.logNo,
							link: {
								name: 'detail',
								params: {
									identifier: metaLog.logId
								}
							}
						};
					}
				}
				return {};
			}
		}
	}
</script>

<style lang="scss" scoped>
	.table-title p {
		margin: 0;
	}
</style>